export const API_KEY = 'AIzaSyD7PEuJ8KF2Wd6D5aQzU6hGZ5UQ3jH15TU';


export const BASE_URL = process.env.REACT_APP_API_URL;

// qa auth
export const AUTH_TOKEN = 'em95YXBwOnpveXBhc3M=';

export const  Google_Map_Api_Key= "AIzaSyD7PEuJ8KF2Wd6D5aQzU6hGZ5UQ3jH15TU";



export const USERNAME = 'zoyapp';
export const PASSWORD = 'zoypass';
export const FIREBASE_SIGNIN = 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=';

export const aes_secret_key = 'TUR0SE0yWWhRUm43V0NJMWdXNVNNVW43T2duOEY1dEo=';
export const iv_base = 'T0tlRDNLdU9WQVNnQktHRA==';
export const map_key =
  'HcpY7Cdeaa08GTaTjwLV4r7MB94n3L6VZVmQ6M9p4LmVmwVpSvfJKFN9PNn55rAD';
export const googleApiUrl = 'https://maps.googleapis.com/maps/api/place/textsearch/json';
export const googleWebClientId = `694212252477-21t1l7ljesi3oh7i8lroousk14mbudj2.apps.googleusercontent.com`;
export const GEOCODE_API_URL = `https://maps.googleapis.com/maps/api/geocode/json`;
export const NEARBY_PLACES_API_URL = `https://maps.googleapis.com/maps/api/place/nearbysearch/json`;